import { Group } from '~/components/component-library/Group'
import { Toggle } from '~/components/component-library/Toggle'
import { StandardToggleableProps } from '~/components/component-library/Toggleable/types'
import { Tooltip } from '~/components/component-library/Tooltip'
import { cn } from '~/utils/tailwind-utils'

export const StandardToggleable = ({
  label,
  description,
  tooltip,
  isChecked,
  onCheckedChange,
  isDisabled = false,
  disabledReason,
}: StandardToggleableProps) => {
  const toggle = (
    <Toggle isChecked={isChecked} size="base" isDisabled={isDisabled} />
  )

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isChecked}
      aria-disabled={isDisabled || undefined}
      tabIndex={isDisabled ? -1 : undefined}
      className={cn(
        'relative block w-full rounded-lg text-left outline-none focus-visible:ring-2 focus-visible:ring-focus',
        { 'cursor-pointer': !isDisabled, 'cursor-not-allowed': isDisabled },
      )}
      onClick={() => {
        if (!isDisabled) onCheckedChange(!isChecked)
      }}
    >
      <Group
        layout="horizontal"
        label={label}
        description={description}
        tooltip={tooltip}
      >
        {isDisabled && disabledReason ? (
          // The trigger wraps only the Toggle so the tooltip centers above
          // it, while the before: overlay (positioned against the relative
          // row button) keeps the whole row as the hover target.
          <Tooltip
            content={disabledReason}
            triggerClassName="flex before:absolute before:inset-0"
          >
            {toggle}
          </Tooltip>
        ) : (
          toggle
        )}
      </Group>
    </button>
  )
}
